import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';
import { Platform } from '@angular/cdk/platform';
import { OverlayContainer } from '@angular/cdk/overlay';
import * as i0 from "@angular/core";
import * as i1 from "@angular/cdk/platform";
/** Container inside which all overlays will render. */
export class WPOverlayContainer extends OverlayContainer {
    constructor(_document, platform) {
        super(_document, platform);
    }
    _createContainer() {
        const containerClass = 'cdk-overlay-container';
        const oppositePlatformContainers = this._document.querySelectorAll(`.${containerClass}`);
        if (containerClass) {
            const container = this._document.createElement('div');
            container.classList.add(containerClass);
            container.classList.add('wp-cdk-overlay-container');
            this._document.body.appendChild(container);
            this._containerElement = container;
        }
        else {
            this._containerElement = oppositePlatformContainers[0];
        }
    }
}
WPOverlayContainer.ɵfac = function WPOverlayContainer_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || WPOverlayContainer)(i0.ɵɵinject(DOCUMENT), i0.ɵɵinject(i1.Platform)); };
WPOverlayContainer.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: WPOverlayContainer, factory: WPOverlayContainer.ɵfac, providedIn: 'root' });
//# sourceMappingURL=overlay-container.js.map